import { Component, OnInit, ViewChild, Input, Output, EventEmitter, AfterViewInit, OnChanges, SimpleChanges, ElementRef, ViewChildren, QueryList } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { catchError, finalize, map } from 'rxjs/operators';
import { BehaviorSubject, Observable, of, merge } from 'rxjs';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';



import { SupervisionError, SupervisionErrorStatusEnum, SupervisionStatusEnum } from 'solar-bo';
import { IssueListBaseComponent } from './issue-list-base.component';
import { SortHelper } from 'shtools';
import { environment } from '@app-environments/environment.prod';
import { CanvasIssueConfig } from '@solar/solar/models';
import { OperMantComponent } from './ooermant/opermant.component';
import { OMItem } from '@solar/solar/models/omitem.model';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { NotificationType } from 'base-models';
//import { CanvasIssueConfig } from '@solar/models';


@Component({
  selector: 'app-ex-issue-list',
  templateUrl: './issue-list-3.component.html',
  styleUrls: ['./issue-list-3.component.scss']
})
export class IssueListComponent extends IssueListBaseComponent implements OnInit, AfterViewInit, OnChanges {

  @ViewChild('issueCDKViewPort') issueCDKViewPort: CdkVirtualScrollViewport;


  canvas_options = { panelStrokeWidth: 4, markerStrokeColor: "rgb(0,0,0)", markerSize: 20, useIssueColor: false, useDefault: true , zoom:1 };
  //UI OPTIONS
  showPanelType: boolean = true;
  showTempMeasuresMin: boolean = false;
  showOM: boolean = true;
  hasOMAccess: boolean = false;
  showimageDate: boolean = true;

  constructor() {
    //super(dialog, globService, route, baseService, router);
    super();
    this.hasOMAccess = environment.opermaintdemo
  }

  ngOnInit() {

  }
  showTable = true;//hack to try to control height of scroll
  ngAfterViewInit() {
    this.showTable = true;
  }

  ngOnChanges(changes: SimpleChanges) {
    let typeChange = changes['supervision'];
    if (typeChange && typeChange.previousValue == undefined) {
      //this.supervision = typeChange.currentValue;
      if (!this.supervision) {
        return;
      }

      this.site = this.supervision.site;

      if (this.supervision.info.status == SupervisionStatusEnum.LOCKED
        || this.supervision.info.status == SupervisionStatusEnum.VALIDATED) {
        this.svFilter.filter_status = SupervisionErrorStatusEnum.validated;
        this.uiStatusOpen = false;
      }
    }

    typeChange = changes['issues'];
    if (typeChange) {
      console.log("base>> childOnChanges issues");
      this.configIssueList(this.issues);
      this.uiConfigStats();
    }
  }

  selectRowById(id): number {
    let index = this.filteredList.findIndex(elem => elem.id == id);
    if (index > -1) {
      this.scrollToIndex(index);
      this.selectRow(index);
    }
    return index;
  }

  scrollToIndex(index) {
    this.issueCDKViewPort.scrollToIndex(index);
  }

  selectRow(index) {
    let issue2Find: SupervisionError = this.filteredList[index];
    if (issue2Find) {
      this.issueSelected = issue2Find;
    }
  }


  childOnChanges(changes: SimpleChanges) {
    let typeChange = changes['supervision'];
    if (typeChange && !typeChange.firstChange && typeChange.previousValue == undefined) {
      this.supervision = typeChange.currentValue;
      if (!this.supervision) {
        return;
      }
    }

    typeChange = changes['issues'];
    if (typeChange && !typeChange.firstChange) {
      console.log("childOnChanges issues");
      this.configIssueList(this.issues);
    }
  }

  configsource(list) {
    this.filteredList = list;
    if (list && list.length > 0) {
      let firstIssue = list[0];
      this.issueSelected = firstIssue;
      this.issueSelectedEvent.emit(firstIssue);
    }
  }

  changePanel(newPanel) {
    //not used here
  }

  filterListByErrorType() {
    if (this.svFilter.filter_status == SupervisionErrorStatusEnum.none) {
      this.filteredList = this.issues;
    } else {

    }
    try {
      this.uiConfigStats();
    }
    catch (err) {
      this.handleError(err, "Error retrieving supervision issues");
    }

  }
  /**
   * handler for click on column of the issue
   * @param row 
   */
  issueColType_click(row) {
    this.playIssues_stop();
    this.issueShowOnMap(row);
  }
  /**
   * Show fields based on supervision status
   */
  uiShowFieldWhenOpen() {
    if (!this.supervision || !this.supervision.info) {
      return false;
    }

    if (this.supervision.info.status == SupervisionStatusEnum.LOCKED
      || this.supervision.info.status == SupervisionStatusEnum.VALIDATED) {
      return false;
    }
    return true;
  }
  /**
   * NOT USED YET
   * Sort table based on column. If column is a composed object we need to change function
   * @param column 
   */
  sorttable(column: string) {
    let l: any = this.listFiltered;
    if (l != null) {
      l = l.sort((a, b) => SortHelper.sortByString(a[column], b[column]));
    }
  }


  playIssues: boolean = false;
  playIssues_class = "fas fa-play";
  playGallery_class_stop = "fas fa-stop";
  async playissues() {
    if (this.playIssues == false) {
      this.playIssues = true;
      this.playIssues_class = "far fa-stop-circle text-danger";
    } else {
      this.playIssues = false;
      this.playIssues_class = "fas fa-play";
      return;
    }

    let firstitem = -1;
    if (this.issueSelected) {
      firstitem = this.filteredList.findIndex(item => item.id == this.issueSelected.id);
    } else if (this.issues.length > 0) {
      firstitem = 0;
    }

    for (let idx = firstitem; idx < this.filteredList.length; idx++) {
      const item = this.filteredList[idx];
      await this.issueShowOnMapAsync(item, idx);
      if (!this.playIssues) {
        return;
      }
      if (idx == this.filteredList.length - 1) {
        this.playIssues_stop();
        this.showNotificationInfo("End of error list reached.");
      }
    }

  }

  private playIssues_stop() {
    this.playIssues = false;
    this.playIssues_class = "fas fa-play";
  }

  private async issueShowOnMapAsync(item, idx) {
    return new Promise<any>(resolve =>
      setTimeout(resolve, 1000))
      .then(() => {
        if (!this.playIssues) {
          return;
        }
        this.scrollToIndex(idx);
        this.issueShowOnMap(item);
      }
      );
  }

  private findTabBy(id: any) {
    /* let index = this.tabsComponents.findIndex(item => item.id == id);
    return index; */
  }

  //@ViewChild('tabgroup', { static: false }) staticTabs: TabsetComponent;
  tabpanel=['SELECTED',''];
  showHideTab(index){
    //this.staticTabs.tabs[index].
  }

  issue_tab_select(issue){

  }

    /**
   * OM SECTION
   */
  showOperMant(issue: SupervisionError) {
    let dialogRef: MatDialogRef<OperMantComponent> = OperMantComponent.openDialog(this.dialog, this);
    dialogRef.componentInstance.configIssueList([issue]);
    dialogRef.componentInstance.issueSavedEvent.subscribe(res => {
      dialogRef.close()        
    }); 
  }

  showOperMantForList(issueList: SupervisionError[]) {
    let dialogRef: MatDialogRef<OperMantComponent> = OperMantComponent.openDialog(this.dialog, this);
    dialogRef.componentInstance.configIssueList(issueList);
    dialogRef.componentInstance.issueSavedEvent.subscribe(res => {
      dialogRef.close()        
    }); 
  }

  OMItem_getDescription(issue: SupervisionError) {
    if (issue.om) {
      return OMItem.getDescription(issue.om.status);
    }

  }

  omstatus(issue: SupervisionError) {
    if (issue.om) {
      return issue.om.status;
    }
  }

     omMarkForReview() {
      console.log("omMarkForReview", this.issues.length);
      for (let issue of this.issues){
        console.log("Issue to mark is:" , issue.info.panel.name);
      }
      this.showOperMantForList(this.issues);
    }



    private om_saveIssue(issue:SupervisionError) {
      this.listerrmessage = "";
      this.alertmessage = null;
      this.loading = true;
  
      let issueCloned = this.prepareSave(issue);
  
  
      this.solarService.supervisionIssueUpdate(issueCloned)
        .subscribe(
          issueSavedResult => this.saveIssueHandleresult(issue,issueSavedResult)
          , err => this.saveIssueHandleError(err)
        );
    }

    private prepareSave(issueToSave: SupervisionError): any {
  
      let om:OMItem =new OMItem()
      
      om.status = 'TOREVIEW';
      om.reviewedDate = new Date();
      om.comments = '';
      om.modify_user = this.globService.currentUserValue.id;
      om.modify_date=new Date();
  
      const issue = new SupervisionError();
      issue.info = issueToSave.info;
      issue.id = issueToSave.id;
      issue.info["om"] = om;
      
      return issue;
    }
  
    private saveIssueHandleError<T>(err: any) {
      this.loading = false;
      this.submitted = false;
      this.handleError(err, "Error updating issues ");
    }
  
    private saveIssueHandleresult(issueToSave: SupervisionError,issueSaved: SupervisionError) {
      this.listerrmessage = '';
      this.loading = false;
      this.submitted = false;
      //como el servidor devuelve el issue con datos simples hay que asignar algunos datos
      issueToSave.om = issueSaved.info.om;
  
  
      this.showNotification(NotificationType.Success, "Issue O&M saved"); 
    }
  
    /**
     * OM SECTION ENDS
     */
}



